import { GCM_SIGNUP_FAILS } from '../../../../components/gcm/Constants'
import { getLeadSource } from '../../../../utils/analytics/leadSourceHelper'
import redirector from '../../../../utils/redirector'
import { triggerSignup } from '../../../auth/actions/signupUtils'
import createMaldivesItinerary from '../../../tour-packages/actions/createMaldivesItinerary'

export default ({
	lastLocation = {},
	passengerDetail = {},
	passengerConfiguration,
	router,
	appDispatch,
	gcmDispatch,
	userDetails,
	departureDate,
	locale,
	nights,
	departureAirportCode,
	setCtaLoading,
	setVisible,
	setShowErrorModal,
}) => {
	const leadSourceData = getLeadSource({
		router,
		lastLocation,
		version: 'SPEEDBOAT',
	})

	const isUserExist = userDetails && userDetails.loggedIn

	const proceedToMleCreateItinerary = () => {
		const requestData = {
			resortCode: router?.query?.resortCode,
			departureAirportCode,
			departureDate,
			passengerConfiguration,
			arrivalAirportCode: departureAirportCode,
			nights: nights || 4,
			nationality:
				typeof router?.query.nationality === 'string'
					? router?.query.nationality.toUpperCase() || 'IN'
					: 'IN',
		}
		createMaldivesItinerary(
			requestData,
			itineraryId => {
				setCtaLoading(false)
				setVisible(false)
				// redirector(
				// 	`${
				// 		locale ? `/${locale}` : ''
				// 	}/customize/mle/inclusions/${itineraryId}`,
				// )
				redirector(
					`${
						locale ? `/${locale}` : ''
					}/customize/mle/inclusions/calculating-cost/${itineraryId}`,
				)
			},
			() => {
				setCtaLoading(false)
				setVisible(false)
				setShowErrorModal && setShowErrorModal(true)
			},
			router,
			{},
			locale,
		)
	}

	if (isUserExist) {
		proceedToMleCreateItinerary()
	} else {
		const { name, email, mobileNumber, countryPhoneCode } =
			passengerDetail || {}
		let reqObj = {
			countryPhoneCode,
			mobileNumber,
			userName: name,
			email,
			cpid: sessionStorage && sessionStorage.getItem('campaignId'),
			leadSource: leadSourceData,
			canSendWhatsAppMessages: true,
		}

		triggerSignup({
			reqObj,
			signupType: 'SIGNUP',
			leadSource: reqObj.leadSource,
			successSubmitCallback: () => {
				proceedToMleCreateItinerary()
			},
			dispatch: appDispatch,
			failureSubmitCallback: error => {
				if (
					error.status === 'MOBILE_EXISTS' ||
					error.status === 'EMAIL_EXISTS'
				) {
					const noteMessage =
						error.message ||
						'This mobile number is already registered with a different email ID to which the vouchers will be shared to. Please check the account details section after logging in.'

					let defaultState = {
						status: error.status,
						noteMessage,
						alreadyExist: true,
					}
					if (error.status === 'MOBILE_EXISTS') {
						defaultState = {
							...defaultState,
							defaulMobileNumber: `${mobileNumber}`,
							defaultCountryPhoneCode: countryPhoneCode,
						}
					} else {
						defaultState = {
							...defaultState,
							defaultEmail: email,
						}
					}
					gcmDispatch &&
						gcmDispatch({
							type: GCM_SIGNUP_FAILS,
							payload: {
								...defaultState,
							},
						})
				}
			},
		}).catch(() => {})
	}
}
